import React, { useState } from 'react';
import ParentSignupForm from './parent-signup-form';
import SocialSignupGroup from './SocialSignupGroup';
import * as S from './style';

const RightPanel = ({setSignupError, setHideToast, setShowSuspectedPopup, email,
   setEmail, password, setPassword, setSuspectedFormData }) => {
  const [isPrivacyPolicyAccepted, setisPrivacyPolicyAccepted] = useState(false);
  const [isEmailPreference, setIsEmailPreference] = useState(false);
  const isEuropeIP = window.isEuropeIP === "true";

  const SocialLinks = {
    userType: "parent",
    links: ["google", "apple"]
  }

  const handlePrivacyPolicyChange = () =>{
    localStorage.setItem('is_privacy_policy_accepted', !isPrivacyPolicyAccepted);
    setisPrivacyPolicyAccepted(value => !value)
  }

  const handleEmailPreferenceChange = () =>{
    localStorage.setItem('is_email_preference', !isEmailPreference);
    setIsEmailPreference(value => !value)
  }
  return (
    <S.SignupContainerRightPanel>
      {!(window.navigator.userAgent.toLocaleLowerCase().match(/cros|fban|fbav|fbios/) || window.location.host.includes('uk')) &&
        <>
        <SocialSignupGroup
          SocialLinks={SocialLinks}
          setShowSuspectedPopup={setShowSuspectedPopup}
        />
          <S.OrBar>
            <S.OrText>OR</S.OrText>
          </S.OrBar>
        </>
      }
      <S.ParentSignupFormContainer>
        <ParentSignupForm
          isPrivacyPolicyAccepted={isPrivacyPolicyAccepted}
          isEmailPreference={isEmailPreference}
          setSignupError={setSignupError}
          setHideToast={setHideToast}
          setShowSuspectedPopup={setShowSuspectedPopup}
          email={email}
          setEmail={setEmail}
          password={password}
          setPassword={setPassword}
          setSuspectedFormData={setSuspectedFormData}
        />
      </S.ParentSignupFormContainer>
      <S.TeacherSignupLink href="/teachers/register" extraMargin={!isEuropeIP}>Teachers, click here to sign up</S.TeacherSignupLink>
      {isEuropeIP ? <S.PolicyAndNewsLetterBox>
        <S.Choice>
          <S.CheckBox type="checkbox" required={true} onChange={handlePrivacyPolicyChange} />
          <S.Label>
            <S.LabelText>I confirm that I am at least 18 years of age and agree to SplashLearn <a href="/terms-of-use" target="_blank">Terms and Conditions </a> & <a href="/privacy" target="_blank">Privacy Policy</a> <S.AsteriskSign>*</S.AsteriskSign></S.LabelText>
          </S.Label>
        </S.Choice>
        <S.Choice>
          <S.CheckBox type="checkbox" onChange={handleEmailPreferenceChange} />
          <S.Label>
            <S.LabelText>I want to receive newsletters, offers & learning resources from SplashLearn. (You can unsubscribe anytime)</S.LabelText>
          </S.Label>
        </S.Choice>
      </S.PolicyAndNewsLetterBox> : <S.TermsAndPolicyWarning>By Signing up, you agree to our <a href="/terms-of-use" target="_blank">Terms of Use</a> &#38; <a href="/privacy" target="_blank">Privacy Policy</a></S.TermsAndPolicyWarning> }
    </S.SignupContainerRightPanel>
  )
}

export default RightPanel;